// extracted by mini-css-extract-plugin
export var colorSquare = "_qy-0";
export var danger = "_qy-5";
export var lightPink = "_qy-8";
export var neutralBlue = "_qy-7";
export var neutralYellow = "_qy-6";
export var normal = "_qy-1";
export var primary = "_qy-2";
export var primaryLight = "_qy-3";
export var solidBlack = "_qy-g";
export var solidGreen = "_qy-b";
export var solidLightBlue = "_qy-d";
export var solidNavy = "_qy-c";
export var solidOrange = "_qy-f";
export var solidPink = "_qy-e";
export var solidRed = "_qy-9";
export var solidYellow = "_qy-a";
export var success = "_qy-4";